export default __webpack_public_path__ + "static/media/Padron_4000Closed.eadc933a.jpg";